import React from 'react';

function MemeGallery({ memes, adjustFontSize }) { 
  const clampPercent = (value, min, max) => Math.min(Math.max(value, min), max);

  const getPercentValue = (value, fallback, min = 0, max = 100) => {
    const parsedValue = Number.parseFloat(value);
    return Number.isFinite(parsedValue) ? clampPercent(parsedValue, min, max) : fallback;
  };

  const renderMeme = (meme) => {
    const hasOverlayText = typeof meme.overlayText === 'string' && meme.overlayText.trim().length > 0;
    const textLeft = getPercentValue(meme.textPositionX, 0);
    const textTop = getPercentValue(meme.textPositionY, 0);
    const textWidth = getPercentValue(meme.textWidth, Math.max(1, 100 - textLeft), 1, Math.max(1, 100 - textLeft));
    const textHeight = getPercentValue(meme.textHeight, Math.max(1, 100 - textTop), 1, Math.max(1, 100 - textTop));

    return (
    <div key={meme._id} className="meme-gallery-item" style={{ position: 'relative', overflow: 'hidden' }}>
      <img
        src={meme.imageUrl}
        alt="Meme"
        className="meme-gallery-image"
        onLoad={(e) => adjustFontSize(e.target, meme)}
      />
      {hasOverlayText && (
      <div
        className="meme-gallery-text"
        style={{
          position: 'absolute',
          top: `${textTop}%`,
          left: `${textLeft}%`,
          width: `${textWidth}%`,
          height: `${textHeight}%`,
          color: meme.fontColor,
          fontFamily: meme.fontFamily,
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
          padding: 0,
          pointerEvents: 'none',
          textAlign: 'center',
          lineHeight: '1',
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
          maxWidth: '100%',
          maxHeight: '100%',
          overflow: 'hidden',
          clipPath: 'inset(0)',
        }}
      >
        {meme.overlayText}
      </div>
      )}
    </div>
    );
  };

  return (
    <div className="meme-gallery">
      {memes.length === 0 ? (
        <div className="meme-gallery-placeholder">
          <img src="https://imagedelivery.net/mEHe7vWpwEHOhne-YSqzMw/6cc98ecc-5bda-4edd-1e30-1895bb0e5c00/public" alt="No memes" className="placeholder-image" />
          <p className="placeholder-text">No memes have been created yet. Be the first to share a laugh!</p>
        </div>
      ) : (
        renderMeme(memes[0]) 
      )}
    </div>
  );
}

export default MemeGallery;

